export const edgeData = [
  { source: "Jim", target: "Irene", weight: 5 },
  { source: "Susie", target: "Irene", weight: 5 },
  { source: "Miles", target: "Irene", weight: 5 },
  { source: "Shirley", target: "Kai", weight: 5 },
  { source: "Shelby", target: "Kai", weight: 5 },
  { source: "Erik", target: "Miles", weight: 2 },
  { source: "Elijah", target: "Enrico", weight: 2 },
  { source: "Enrico", target: "Moritz", weight: 2 },
  { source: "Moritz", target: "ET", weight: 2 }
]
